import type { NotificationWritePort, NotificationPreferences, PushToken } from '../core/types';
import type { TablesInsert } from '@/integrations/supabase/types';

export interface NotificationCommandService {
  createNotification(data: TablesInsert<'notifications'>): Promise<{ id: string }>;
  markAsRead(notificationId: string): Promise<void>;
  markAllAsRead(userId: string): Promise<void>;
  upsertPreferences(userId: string, prefs: Partial<NotificationPreferences>): Promise<void>;
  registerPushToken(userId: string, token: string, platform: PushToken['platform']): Promise<void>;
  removePushToken(token: string): Promise<void>;
}

export function createNotificationCommandService(port: NotificationWritePort): NotificationCommandService {
  return {
    createNotification: (data) => port.createNotification(data),
    markAsRead: (id) => port.markAsRead(id),
    markAllAsRead: (userId) => port.markAllAsRead(userId),
    upsertPreferences: (userId, prefs) => port.upsertPreferences(userId, prefs),
    registerPushToken: (userId, token, platform) => port.registerPushToken(userId, token, platform),
    removePushToken: (token) => port.removePushToken(token),
  };
}
